import React from "react";
import { useState } from "react";
import "../../../pages/SalesMasterPages/TrainListTest/TrainList.css";
import DeleteOutlinedIcon from "@mui/icons-material/DeleteOutlined";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";

const TrainList = ({ trainData }) => {
  // Check if trainData is an array before using map
  if (Array.isArray(trainData)) {
    return (
      <div className="container-fluid">
        <div className="TrainList">
          <table>
            <thead>
              <tr className="TrainListHeading">
                <th>S No.</th>
                <th>Train From</th>
                <th>Train To</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {trainData.map((region, index) => (
                <tr key={region.region_id}>
                  <td>{++index}</td>
                  <td>{region.from}</td>
                  <td>{region.to}</td>
                  <td>
                    <button
                      style={{
                        height: "35px",
                        width: "35px",
                        backgroundColor: "#F1F1F1",
                      }}
                    >
                      <EditOutlinedIcon className="icon" />
                    </button>
                    <button
                      style={{
                        height: "35px",
                        width: "35px",
                        marginLeft: "5px",
                        backgroundColor: "#F4616F",
                        borderColor: "#FF0000",
                      }}
                    >
                      <DeleteOutlinedIcon className="icon" />
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    );
  } else {
    return (
      <div className="container-fluid">
        <div className="TrainList">
          <table>
            <thead>
              <tr className="TrainListHeading">
                <th>S No.</th>
                <th>Train From</th>
                <th>Train To</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td colSpan="4">No data to display</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
};

export default TrainList;
